import type { ButtonHTMLAttributes, Ref } from "react";
import { classes } from "../../nucleo/classes";

export type VarianteDeBotao = "solido" | "fantasma" | "verde";
export type TamanhoDeBotao = "medio" | "pequeno";

export interface PropsDoBotao extends ButtonHTMLAttributes<HTMLButtonElement> {
  variante?: VarianteDeBotao;
  tamanho?: TamanhoDeBotao;
  /** Ocupa toda a largura disponível. */
  larguraTotal?: boolean;
  ref?: Ref<HTMLButtonElement>;
}

const VARIANTES: Record<VarianteDeBotao, string> = {
  solido: "",
  fantasma: "botao--fantasma",
  verde: "botao--verde",
};

export function Botao({
  variante = "solido",
  tamanho = "medio",
  larguraTotal = false,
  className,
  type = "button",
  ...resto
}: PropsDoBotao) {
  return (
    <button
      // `type` explícito: dentro de um formulário o padrão do HTML é `submit`, e um botão
      // de ação secundária enviaria o formulário sem querer.
      type={type}
      className={classes(
        "botao",
        VARIANTES[variante],
        tamanho === "pequeno" && "botao--pequeno",
        larguraTotal && "botao--total",
        className,
      )}
      {...resto}
    />
  );
}
